import { render, staticRenderFns } from "./OrderDetailItemsRow.vue?vue&type=template&id=c2cc3434&scoped=true&"
import script from "./OrderDetailItemsRow.vue?vue&type=script&lang=js&"
export * from "./OrderDetailItemsRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailItemsRow.vue?vue&type=style&index=0&id=c2cc3434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc3434",
  null
  
)

export default component.exports